import { useEffect, useState } from "react"
import "./index.less"
import { DeviceModelingDetail } from "@/global/interface/device/sensor"
import TnInput from "@/global/components/input/tn-input"
import TextArea from "rc-textarea"
import { addSensorModelingDetail, findModelingDetailBySensorId } from "@/api/device/sensor"
import { useParams } from "react-router"
import { updateDeviceModelingDetail } from "@/api/device/device"
import TnMessage from "@/global/components/message"
import { DatePicker } from "antd"
import dayjs from "dayjs"

interface Iprops {
    sensorId: number
}

export default function SensorModelingPanel(props: Iprops) {

    const { projectId } = useParams()

    const [model, setModel] = useState<DeviceModelingDetail>(null)

    useEffect(() => {
        generateData()
    }, [])

    const generateData = () => {
        if (props.sensorId) {
            findModelingDetailBySensorId(props.sensorId).then(res => {
                let data = res.data
                if (data) {
                    setModel(data)
                } else {
                    addSensorModelingDetail(Number(projectId), props.sensorId, {}).then(res => {
                        let modelId: number = res.data
                        setModel({ id: modelId })
                    })
                }
            })
        }
    }

    const updateModeling = (key: string, value: any) => {
        if (model) {
            let updateData = {}
            updateData[key] = value
            updateDeviceModelingDetail(model.id, updateData).catch(() => {
                TnMessage.error("更新失败！")
            })
        }
    }

    const onValueChange = (key: string, value: any) => {
        if (!model) return
        if (key == "person") {
            model.person = value
        } else if (key == "phone") {
            model.phone = value
        } else if (key == "geometryPosition") {
            model.geometryPosition = value
        } else if (key == "attachObject") {
            model.attachObject = value
        } else if (key == "logicPosition") {
            model.logicPosition = value
        } else if (key == "modelingTime") {
            model.modelingTime = value
        }
        setModel({ ...model })

    }


    return (
        <div className="modeling-main">
            <div className="title">
                建模
            </div>
            <div className="modeling-detail">
                <div className="item">
                    <div className="label">
                        建模时间
                    </div>
                    <div className="value">
                        <DatePicker
                            value={dayjs(model?.modelingTime)}
                            onChange={(e) => {
                                onValueChange("modelingTime", e.valueOf())
                                updateModeling("onValueChange", e.valueOf())
                            }}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        建模人员
                    </div>
                    <div className="value">
                        <TnInput
                            value={model?.person || ""}
                            onBlur={(e) => { updateModeling("person", e) }}
                            onTextChange={(text) => { onValueChange("person", text) }}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        电话
                    </div>
                    <div className="value">
                        <TnInput
                            value={model?.phone || ""}
                            onBlur={(e) => { updateModeling("phone", e) }}
                            onTextChange={(text) => { onValueChange("phone", text) }}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        几何定位
                    </div>
                    <div className="value">
                        <TextArea
                            value={model?.geometryPosition || ""}
                            className="value-text-area"
                            onBlur={(e) => { updateModeling("geometryPosition", e.target.value) }}
                            onChange={(e) => { onValueChange("geometryPosition", e.target.value) }}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        依附对象
                    </div>
                    <div className="value">
                        <TnInput
                            value={model?.attachObject || ""}
                            onBlur={(e) => { updateModeling("attachObject", e) }}
                            onTextChange={(text) => { onValueChange("attachObject", text) }}
                        />
                    </div>
                </div>
                <div className="item">
                    <div className="label">
                        逻辑定位
                    </div>
                    <div className="value">
                        <TnInput
                            value={model?.logicPosition || ""}
                            onBlur={(e) => { updateModeling("logicPosition", e) }}
                            onTextChange={(text) => { onValueChange("logicPosition", text) }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}